import MicroModal from 'micromodal';
import { isLocalUrl } from '../utils.js';

export default function managedPopup() {
  const widgetName = 'managedPopUp';
  const widgetOpts = managedPopUpOpts;

  // Storage selector-------------
  const sectionTrigger = 'homepage';

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (data) {
      const {
        Description: modalDescription,
        Title: modalTitle,
        URL: modalBtnLink,
        ImageWithPath: modalImg,
        DetailLinkText: modalBtnText,
      } = data.items[0];
      console.log(data.items[0]);

      // remove the " from modalImg

      const targetBlank = isLocalUrl(modalBtnLink);

      function initializePopupModal() {
        $('body').append(`
          <div class="micromodal-slide" id="modal" aria-hidden="true">
            <div class="modal__overlay" tabindex="-1">
              <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title" aria-describedby="modal-desc">
                <button class="modal-close-btn" data-micromodal-close aria-label="Close Dialog">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="image-container" style="background-image: url('${modalImg}')"></div>
                <div class="text-container">
                  <h2 id="modal-title" >${modalTitle}</h2>
                  <p id="modal-desc">${modalDescription}</p>   
                   ${modalBtnLink ? `<a class="button" href="${modalBtnLink}" aria-label="Signup: ${modalTitle}" ${targetBlank}>${modalBtnText}</a>` : ''}
                </div>
              </div>
            </div>
          </div>
        `);

        MicroModal.show('modal');
      }

      function handlePopup() {
        if ($('body').hasClass(sectionTrigger)) {
          const modalShown = localStorage.getItem('modalShown');
          const lastShown = parseInt(modalShown || '0', 10);
          const oneDayMs = 24 * 60 * 60 * 1000;
          const expired = Date.now() - lastShown > oneDayMs;

          if (!modalShown || expired) {
            setTimeout(() => {
              // localStorage.setItem('modalShown', Date.now().toString());
              initializePopupModal();
            }, 1200);
          } else {
            $('#modal').remove();
          }
        } else {
          $('#modal').remove();
        }
      }
      handlePopup();
    },
    itemsPerPanel: 1,
    link: [],
    maxItemsVisible: 1,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
  });
}
